

const requiredInputs = {
    name: 'requiredInputs',
    fields: [{
        colspan: { lg: 3, md: 6, sm: 12 },
        items: [
            { id: '1', description: 'Width, Height, Airflow' },
            { id: '2', description: 'Width, Airflow, Pressure Drop' },
            { id: '3', description: 'Height, Airflow, Pressure Drop' }
        ],
        name: 'selectionmethod',
        type: 'select'
    }, {
        colspan: { lg: 2, md: 6, sm: 12 },
        decimals: 2,
        maxValue: 3000.00,
        minValue: 1.00,
        name: 'width',
        required: true,
        type: 'numeric'
    }, {
        colspan: { lg: 2, md: 4, sm: 12 },
        decimals: 2,
        maxValue: 3000.00,
        minValue: 0.00,
        name: 'height',
        required: true,
        type: 'numeric'
    }, {
        colspan: { lg: 2, md: 4, sm: 12 },
        maxLength: 6,
        minValue: 1,
        name: 'flow',
        required: true,
        type: 'numeric'
    }, {
        colspan: { lg: 3, md: 6, sm: 12 },
        decimals: 2,
        maxValue: 999999.99,
        minValue: 0.00,
        name: 'pressure',
        required: true,
        type: 'numeric'
    }, {
        colspan: { lg: 2, md: 6, sm: 12 },
        items: [
            { id: 'intake', description: 'Intake' },
            { id: 'exhaust', description: 'Exhaust' }
        ],
        name: 'intakeexhaust',
        type: 'select'
    }]
};

const advanceInputs = {
    defaultExpanded: false,
    name: 'advanceInputs',
    fields: [{
        colspan: { lg: 3, md: 6, sm: 12 },
        items:
            [{ id: 1.50, description: '1 1/2"' },
            { id: 2.00, description: '2"' },
            { id: 3.00, description: '3"' },
            { id: 4.00, description: '4"' },
            { id: 5.00, description: '5"' },
            { id: 6.00, description: '6"' },
            { id: 7.00, description: '7"' },
            { id: 8.00, description: '8"' },
            { id: 12.00, description: '12"' }
            ],
        name: 'louverDepth',
        type: 'multiselect'
    }, {
        colspan: { lg: 3, md: 6, sm: 12 },
        items: [
            { id: 'AI', description: 'Aluminium' },
            { id: 'Galv', description: 'GalvSteel' },
        ],
        name: 'material',
        type: 'multiselect'
    }, {
        colspan: { lg: 3, md: 6, sm: 12 },
        items: [
            { id: 'Airfoil', description: 'Airfoil' },
            { id: 'drainable', description: 'Drainable' },
            { id: 'nonDrainable', description: 'Non - Drainable' },
            { id: 'sightproof', description: 'Sightproof' }
        ],
        name: 'bladeType',
        type: 'multiselect'
    }]
};

const certificationOrSpecialRequirement = {
    defaultExpanded: false,
    name: 'certificationOrSpecialRequirement',
    fields: [{
        colspan: { lg: 3, md: 6, sm: 12 },
        items: [
            { id: 1, description: 'AMCA540 (Basic)' },
            { id: 2, description: 'AMCA 540(Enhanced)' },
            { id: 3, description: 'AMCA 500-L' },
            { id: 4, description: 'AMCA 550' },
            { id: 5, description: 'Miami Dade (TAS 100A)' },
            { id: 6, description: 'Miami Dade (TAS 201-203)' },
            { id: 7, description: 'FEMA' },
            { id: 8, description: 'TDI' }
        ],
        name: 'certification',
        type: 'multiselect'
    }
        , {
        colspan: { lg: 3, md: 6, sm: 12 },
        items: [
            { id: 1.15, description: '1.15' },
            { id: 1, description: '1' }
        ],
        name: 'wpFactor',
        type: 'select'
    }]
};


export default [requiredInputs, certificationOrSpecialRequirement, advanceInputs];